<template>
    <div>
        <div style="margin: 3px 0px 3px 0px;padding: 3px;background: white">
            <el-row style="display: flex">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-folder-add" circle @click="add" type="primary"></el-button>
                </el-tooltip>
                <!--<el-tooltip class="item" effect="dark" content="批量删除" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-delete-solid" circle @click="ifBatchDel()" type="primary"></el-button>
                </el-tooltip>-->
                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-refresh-right" circle @click="reflash" type="success"></el-button>
                </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="导出销售记录" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-download" circle @click="expt" type="warning"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="下载模板" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-download" circle @click="download" type="info"></el-button>
                </el-tooltip>
                  <el-upload
                        class="upload-demo"
                        :action="uploadurl"
                        :file-list="fileList"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :auto-upload="true"
                        :show-file-list="false"
                        :limit="1">
                    <el-tooltip class="item" effect="dark" content="上传" placement="bottom" style="margin-left: 8px">
                     <el-button icon="el-icon-upload2" circle  type="primary"></el-button>
                   </el-tooltip>
                 </el-upload>
            </el-row>
            <el-row>
                <el-date-picker v-if="browser"
                                v-model="begintime"
                                type="datetime"
                                size="medium"
                                value-format="yyyy-MM-dd hh:mm:ss"
                                placeholder="开始日期"
                                style="margin-left: 8px">
                </el-date-picker>
                <el-date-picker v-if="!browser"
                                v-model="begintime"
                                type="date"
                                size="medium"
                                placeholder="开始日期"
                                format="yyyy/MM/dd"
                                value-format="yyyy/MM/dd"
                                style="margin-left: 8px">
                </el-date-picker>
                ~
                <el-date-picker v-if="browser"
                                v-model="endtime"
                                type="datetime"
                                size="medium"
                                placeholder="结束日期"
                                value-format="yyyy-MM-dd hh:mm:ss">
                </el-date-picker>
                <el-date-picker v-if="!browser"
                                v-model="endtime"
                                type="date"
                                size="medium"
                                placeholder="结束日期"
                                format="yyyy/MM/dd"
                                value-format="yyyy/MM/dd">
                </el-date-picker>
                <el-select v-model="status" clearable size="medium" style="margin-left: 8px">
                    <el-option key="0" label="草稿" value="0"></el-option>
                    <el-option key="1" label="新建" value="1"></el-option>
                    <el-option key="2" label="提交" value="2"></el-option>
                    <el-option key="3" label="审核" value="3"></el-option>
                    <el-option key="4" label="驳回修改" value="4"></el-option>
                </el-select>
                <el-input v-model="queryKey" type="text"
                          @click.native.prevent="getView"
                          @keyup.enter.native="getView"
                          suffix-icon="el-icon-search"
                          size="medium" style="width:200px;margin-left: 8px"></el-input>
                <el-tooltip class="item" effect="dark" content="查询" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-search" circle @click="getView"></el-button>
                </el-tooltip>
            </el-row>
        </div>
        <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="dealeriid" label="经销商ID"></el-table-column>-->
            <el-table-column show-overflow-tooltip prop="dealername" label="经销商名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="rolelv" label="级别">
                <template scope="scope">
                    <span>{{explevel(scope.row.rolelv)}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="sondealeriid" label="子经销商">
                <template scope="scope">
                    <span>{{expdealeriid(scope.row.sondealeriid)}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="salearea" label="售卖区域"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productname" label="售卖产品"></el-table-column>
            <el-table-column show-overflow-tooltip prop="salemoney" label="售卖价格" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="salenum" label="售卖数量" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="salecode" label="售卖单号">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="cusname" label="客户名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="payvoucher" label="合同凭证">
                <template scope="scope">
                    <a style="color: blue" @click="showFile(scope.row.payvoucher)" v-if="scope.row.payvoucher != ''">查看</a>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="bill" label="发票凭证">
                <template scope="scope">
                    <a style="color: blue" @click="checkFile(scope.row.bill)" v-if="scope.row.bill != ''">查看</a>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="status" label="状态">
                <template scope="scope">
                    <span>{{expstatus(scope.row.status)}}</span>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="260">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editInfo(scope.row)" type="text" size="small" v-if="scope.row.status == 0 || scope.row.status == 1 || scope.row.status == 4">编辑</el-button>
                    <el-button @click.native.prevent="confirmdel(scope.row)" type="text" size="mini" v-if="scope.row.status == 0 || scope.row.status == 1 || scope.row.status == 4">删除</el-button>
                    <el-button @click.native.prevent="showProductCode(scope.row)" type="text" size="mini">查看编码</el-button>
                    <el-button @click.native.prevent="showAddProductCode(scope.row)" type="text" size="mini" v-if="scope.row.status == 0 || scope.row.status == 1 || scope.row.status == 4">选择编码</el-button>
                    <el-button @click.native.prevent="submit(scope.row,2)" type="text" size="mini" v-if="scope.row.status == 0 || scope.row.status == 1 || scope.row.status == 4">提交</el-button>
                    <!--<el-button @click.native.prevent="submit(scope.row,3)" type="text" size="mini" v-if="scope.row.status == 2">审核</el-button>
                    <el-button @click.native.prevent="showDown(scope.row)" type="text" size="mini" v-if="scope.row.status == 2">驳回修改</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="isShowEdit" width="80%" :close-on-click-modal="false">
            <el-row style="margin-top: 20px">
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="8rem" label-position="left" size="small">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="子经销商">
                                    <el-select v-model="arrsoniids" multiple placeholder="请选择">
                                        <el-option
                                                v-for="item in arrsondealeriid"
                                                :key="item.iid"
                                                :label="item.dealername"
                                                :value="item.iid">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="售卖区域">
                                    <el-input v-model="dataDetail.salearea" size="mini" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="售卖产品">
                                    <!--<el-input v-model="dataDetail.productname" size="mini"></el-input>-->
                                    <el-select filterable v-model="dataDetail.productiid" size="mini">
                                        <el-option v-for="item in arrproductname" :key="item.iid" :label="item.productname" :value="item.iid"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="售卖价格">
                                    <el-input v-model="dataDetail.salemoney" type="number" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <!--<el-col :span="6">
                                <el-form-item label="编码产品">
                                    &lt;!&ndash;<el-input v-model="dataDetail.productname" size="mini"></el-input>&ndash;&gt;
                                    <el-select v-model="arrsalecode" multiple placeholder="请选择">
                                        <el-option
                                                v-for="item in arrproductcode"
                                                :key="item.iid"
                                                :label="item.productcode"
                                                :value="item.iid">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>-->
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="售卖数量">
                                    <el-input v-model="dataDetail.salenum" type="number" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="客户名称">
                                    <el-input v-model="dataDetail.cusname" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="合同凭证">
                                    <el-upload
                                            action="''"
                                            :on-change="fileChange1"
                                            :on-remove="handleRemove1"
                                            :file-list="fileList1"
                                            :on-preview="handlePreview1"
                                            :auto-upload="false">
                                        <el-button size="mini" type="primary">点击上传</el-button>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票凭证">
                                    <el-upload
                                            action="''"
                                            :on-change="fileChange2"
                                            :on-remove="handleRemove2"
                                            :file-list="fileList2"
                                            :on-preview="handlePreview2"
                                            :auto-upload="false"
                                            :limit="1">
                                        <el-button size="mini" type="primary">点击上传</el-button>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="销售单号">
                                    <el-input v-model="dataDetail.salecode" size="mini" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="销售单时间">
                                    <el-date-picker v-model="dataDetail.saletime" type="datetime" placeholder="选择日期时间" size="mini" value-format="yyyy-MM-dd hh:mm:ss" v-if="browser"></el-date-picker>
                                    <el-date-picker v-model="dataDetail.saletime" type="date" placeholder="选择日期时间" size="mini" format="yyyy/MM/dd" value-format="yyyy/MM/dd" v-if="!browser"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
            <div><span>提示：只能上传jpg/png/pdf类型文件，且不超过5MB</span></div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false">关闭</el-button>
                <el-button type="primary" @click="onSubmit(0)" v-if="dataDetail.status == 0 || dataDetail.status == 1">草稿</el-button>
				<el-button type="primary" @click="onSubmit(1)">保存</el-button>
			</span>
        </el-dialog>

        <el-dialog :visible.sync="isShowDown" width="40%" :close-on-click-modal="false" >
            <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回意见"
                    v-model="remark"
                    style="margin-top: 20px">
            </el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowDown = false">关闭</el-button>
				<el-button type="primary" @click="submit('',4)">保存</el-button>
			</span>
        </el-dialog>

        <productcode :isVisible="productcodevisible" @addproductcode="addproductcode" ref="addproducts"></productcode>
        <showproductcode :isVisible="showproductcodevisible" ref="showproducts"></showproductcode>

        <el-dialog :visible.sync="isShowFile" width="30%" :close-on-click-modal="false">
            <div style="margin-top: 15px;min-height: 300px">
                <li v-for="(item,i) in fileArr" v-bind:key="item" style="color: blue" @click="checkFile(item)">合同信息{{i + 1}}</li>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';

    export default {
        data() {
            return {
                browser: true, // 浏览器类型，false:Safari;true:其他
                dataSet: [], // 主表数据
                dataDetail: {},
                userData: [], // 用户信息
                user: "",
                usercode: "",
                useriid: "",
                userarea: "",
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 250, // 主表高度
                queryKey: "",
                SortList: [],
                ScreenList: [],
                isShowEdit: false, // 是否显示编辑页面
                fileList1:[],
                file1:null,
                fileUrl1:"",
                fileList2:[],
                file2:null,
                fileUrl2:"",
                arrproductname: [],
                arrsondealeriid: [],
                arrsoniids: [],
                arrproductcode: [],
                arrsalecode:[],
                isShowDown: false,
                remark: "", // 驳回意见
                begintime: "",
                endtime: "",
                status: "",
                fileList:[],
                uploadurl:'',
                productcodevisible: false,
                showproductcodevisible: false,
                selectData: [], //多选
                isShowFile: false,
                fileArr: []
            };
        },
        mounted: function () {
            let that = this
            that.browser = that.getbrowser()
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.token = that.userData.token
            that.user = that.userData.username
            that.usercode = that.userData.Login_Code
            that.useriid =  that.userData.iid
            that.userarea = that.userData.area
            let parm = {
                tableName: "sys_product",
                columnName: "productname",
                iid: that.useriid
            }
            $.ajax({
                url: Common.Url + 'BaseData/Query?token=' + that.token,
                type: 'post',
                async: false,
                data: JSON.stringify(parm),
                contentType: 'application/json',
                success: function(res) {
                    if (res.Success == 1) {
                        that.arrproductname = res.DataContent;
                    } else {
                        //Message.error(res.Msg);
                    }
                },
                error: function(xhr, errorType, error) {
                    //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                }
            });
            let parm1 = {
                iid: that.useriid
            }
            $.ajax({
                url: Common.Url + '/SysDealerUsers/ChildView?token=' + that.token,
                type: 'post',
                async: false,
                data: JSON.stringify(parm1),
                contentType: 'application/json',
                success: function(res) {
                    if (res.Success == 1) {
                        that.arrsondealeriid = res.DataContent;
                    } else {
                        //Message.error(res.Msg);
                    }
                },
                error: function(xhr, errorType, error) {
                    //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                }
            });
            that.getView();
            let param = {
                    TemplateID: 4,
                    UserName: that.user,
                    UserCode: that.usercode,
                    dealeriid:that.useriid
             };
            let strparam = JSON.stringify(param);
            that.uploadurl =  Common.Url + 'Sys/Import?JsonParam='+strparam;
        },
        methods: {
            getcode(value){
                let that = this
                let parm2 = {
                    tableName: "sys_productcode",
                    columnName: "",
                    iid: that.useriid,
                    productiid: value,
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                }
                $.ajax({
                    url: Common.Url + '/BaseData/PCodeByDealeriid?token=' + that.token,
                    type: 'post',
                    async: false,
                    data: JSON.stringify(parm2),
                    contentType: 'application/json',
                    success: function(res) {
                        if (res.Success == 1) {
                            that.arrproductcode = res.DataContent;
                        } else {
                            //Message.error(res.Msg);
                        }
                    },
                    error: function(xhr, errorType, error) {
                        //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
            },
            fileChange1(file, fileList) {
                let that = this;
                let testFile = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
                const extension = testFile === 'jpg' || testFile === 'png' || testFile === 'pdf';
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!extension){
                    this.$message({
                        type: 'warning',
                        message: '只能上传jpg/png/pdf类型文件!'
                    });
                    that.fileUrl1 = ""
                    that.fileList1 = []
                    return false;
                }else if (!isLt5M) {
                    this.$message.error('上传文件大小不能超过 5MB!');
                    that.fileUrl1 = ""
                    that.fileList1 = []
                    return false;
                } else {
                    that.fileList1 = []
                    that.fileList1 = that.fileList1.concat(fileList)
                }
            },
            handlePreview1(file) {
                let that = this;
                window.open(file.url);
            },
            handleRemove1(file, fileList){
                let that = this
                let arr = []
                let str = ''
                arr = that.dataDetail.payvoucher.split(',')
                for(let i = 0;i<arr.length;i++){
                    if(arr[i] == file.route){
                        arr.splice(i,1)
                        break
                    }
                }
                for(let i = 0;i<arr.length;i++){
                    str = str + arr[i] + ','
                }
                that.dataDetail.payvoucher = str.substr(0,str.length-1)
            },
            fileChange2(file, fileList) {
                let that = this;
                let testFile = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
                const extension = testFile === 'jpg' || testFile === 'png' || testFile === 'pdf';
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!extension){
                    this.$message({
                        type: 'warning',
                        message: '只能上传jpg/png/pdf类型文件!'
                    });
                    that.fileUrl2 = ""
                    that.fileList2 = []
                    return false;
                }else if (!isLt5M) {
                    this.$message.error('上传文件大小不能超过 5MB!');
                    that.fileUrl2 = ""
                    that.fileList2 = []
                    return false;
                } else {
                    that.file2 = file.raw;
                }
            },
            handlePreview2() {
                let that = this;
                window.open(that.fileUrl2);
            },
            handleRemove2(file, fileList){
                let that = this
                that.dataDetail.bill = ''
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val
                this.SelectIndexs = val;
                this.getView();
            },
            reflash() {
                let that = this
                that.begintime = ""
                that.endtime = ""
                that.status = ""
                that.queryKey = ""
                that.getView()
            },
            getView() {
                let that = this
                that.loading = true
                if(that.browser == false) {
                    that.begintime = that.begintime.replace(/\//g,"-")
                    that.endtime = that.endtime.replace(/\//g,"-")
                }
                let parm = {
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                    QueryKey: that.queryKey,
                    iid: "",
                    SortList: that.SortList,
                    ScreenList: that.ScreenList,
                    begintime: that.begintime,
                    endtime: that.endtime,
                    status: that.status,
                    dealercode: that.usercode
                };
                that.$http.urlpost('/TransSale/View', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            add() {
                let that = this
                that.isAdd = true;
                let datetime = Common.methods.getDatetime
                that.dataDetail = {
                    iid: "",
                    salecode: "",
                    dealeriid: that.useriid,
                    productiid: "",
                    sondealeriid: null,
                    sondealername: "",
                    sondealercode: "",
                    salenum: 0,
                    salemoney: 0,
                    salearea: that.userarea,
                    payvoucher: "",
                    bill: "",
                    createpersoncode: that.usercode,
                    createpersonname: that.user,
                    createtime: datetime,
                    modifypersoncode: that.usercode,
                    modifypersonname: that.user,
                    modifytime: datetime,
                    saletime: "",
                    remark: "",
                    status: "",
                    cusname: "",
                    orderiid: ""
                }
                that.fileUrl1 = ""
                that.fileList1 = []
                that.fileUrl2 = ""
                that.fileList2 = []
                that.$http.urlpost('/BaseData/GetSaleCode', {}, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.salecode = res.Key
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
                that.isShowEdit = true
            },
            editInfo(row){
                let that = this
                that.isAdd = false;
                that.dataDetail = row
                if(that.dataDetail.sondealeriid != ""){
                    that.arrsoniids = that.dataDetail.sondealeriid.split(',')
                } else {
                    that.arrsoniids = []
                }
                that.file1 = null
                that.file2 = null
                if(that.dataDetail.payvoucher != "") {
                    that.fileList1 = []
                    let arr = that.dataDetail.payvoucher.split(',')
                    for(let i=0;i<arr.length;i++){
                        that.fileList1 = [...that.fileList1,{
                            name: "合同凭证" + (i+1),
                            url: Common.Url + 'uploads/' + arr[i],
                            route: arr[i]
                        }]
                    }
                } else{
                    that.fileUrl1 = ""
                    that.fileList1 = []
                }
                if(that.dataDetail.bill != ""){
                    that.fileUrl2 = Common.Url + 'uploads/' + that.dataDetail.bill
                    that.fileList2 = [{
                        name: "发票凭证",
                        url: that.fileUrl2
                    }]
                } else{
                    that.fileUrl2 = ""
                    that.fileList2 = []
                }
                if(that.browser == false){
                    that.dataDetail.saletime = that.dataDetail.saletime.replace(/-/g,"/")
                }
                that.isShowEdit = true
            },
            confirmdel(row){
                let that = this
                that.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.del(row);
                    })
                    .catch(() => {});
            },
            del(row) {
                let that = this
                let parm ={
                    iid: row.iid,
                    modifytime: row.modifytime,
                    createpersonname: that.user
                }
                that.$http.urlpost('/TransSale/Delete', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            onSubmit(value) {
                let that = this
                let sons = ""
                if(that.dataDetail.salenum == 0){
                    that.$message.warning('售卖数量不能为0')
                    return false
                }
                for(let i=0;i<that.arrsoniids.length;i++){
                    sons = sons + that.arrsoniids[i] + ','
                }
                that.dataDetail.sondealeriid = sons.substr(0,sons.length-1)
                let datetime = Common.methods.getDatetime
                that.dataDetail.modifypersoncode = that.usercode
                that.dataDetail.modifypersonname = that.user
                that.dataDetail.modifytime = datetime
                if(value == 0){
                    that.dataDetail.status = 0
                } else if (that.isAdd == true && value == 1){
                    that.dataDetail.status = 1
                }
                if(that.browser == false){
                    that.dataDetail.saletime = that.dataDetail.saletime.replace(/\//g,"-")
                }
                let parm = that.dataDetail
                that.$http.urlpost('/TransSale/Edit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isShowEdit = false
                        let iid = res.Key
                        if(that.fileList1.length != 0){
                            that.uploadFileBatch(that.fileList1,iid,2)
                        }
                        if(that.file2 != null){
                            that.uploadFile(that.file2,iid,1)
                        }
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            uploadFile(file, iid, type) {
                let that = this;
                let formData = new FormData(); //formdata格式
                formData.append('file', file);
                formData.append('iid', iid)
                formData.append('type', type)
                that.$http.urlpost('/TransSale/UploadFile', formData, function (res) {
                    if (res.Success == 1) {
                        that.getView()
                    }
                });
            },
            uploadFileBatch(file,iid,type){
                let that = this;
                let formData = new FormData(); //formdata格式
                formData.append('iid', iid)
                formData.append('type', type)
                that.fileList1.forEach(file => {
                    if(file.raw != undefined){
                        formData.append('file', file.raw);
                    }
                });
                if(formData.get("file") == null){
                    return false
                }
                that.$http.urlpost('/BaseData/UploadFiles', formData, function (res) {
                    if (res.Success == 1) {
                        that.getView()
                    }
                });
            },
            submit(row,type){
                let that = this
                let parm = {}
                if(type == 4){
                    parm = {
                        iid: that.dataDetail.iid,
                        action_user: that.user,
                        modifytime: that.dataDetail.modifytime,
                        status: type,
                        remark: that.remark
                    }
                    that.$http.urlpost('/TransSale/SetStatus', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(Common.SuccessMsg);
                            that.remark = ""
                            that.isShowDown = false
                            that.getView()
                        } else {
                            that.$message.error(res.Msg);
                        }
                    });
                } else {
                    parm = {
                        iid: row.iid,
                        action_user: that.user,
                        modifytime: row.modifytime,
                        status: type,
                        remark: that.remark
                    }
                    that.$confirm('是否提交?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            that.$http.urlpost('/TransSale/SetStatus', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(Common.SuccessMsg);
                                    that.getView()
                                } else {
                                    that.$message.error(res.Msg);
                                }
                            });
                        })
                        .catch(() => {
                        });
                }

            },
            showDown(row) {
              let that = this
              that.isShowDown = true
                that.dataDetail = row
            },
            showProductCode(row) {
                let that = this
                that.iid = row.iid
                that.dealeriid = row.dealeriid
                that.showproductcodevisible = true
                let parm = {
                    PageSize: 99999,
                    PageIndex: 1,
                    QueryKey: "",
                    iid: "",
                    SortList: [],
                    ScreenList: [],
                    dealercode: "",
                    productcodestatus: "",
                    orderiid: "",
                    saleiid: row.iid
                };
                that.$http.urlpost('/SysProductCode/View', parm, function (res) {
                    if (res.Success == 1) {
                        let arr = res.DataContent;
                        that.$refs.showproducts.clearInput(that.showproductcodevisible, arr);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            // 添加产品id
            showAddProductCode(row) {
                let that = this
                that.iid = row.iid
                that.dealeriid = row.dealeriid
                that.addproductcodevisible = true
                let parm = {
                    PageSize: 5000,
                    PageIndex: 1,
                    QueryKey: "",
                    iid: "",
                    SortList: [],
                    ScreenList: [],
                    dealercode: "",
                    productcodestatus: "",
                    orderiid: "",
                    saleiid: row.iid
                };
                that.$http.urlpost('/SysProductCode/View', parm, function (res) {
                    if (res.Success == 1) {
                        let arr = res.DataContent;
                        that.$refs.addproducts.clearInput(that.addproductcodevisible, arr, row.dealeriid,row.productiid,row.iid,2);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            addproductcode(arr) {
                let that = this
                let iids = ""
                for(let i=0;i<arr.length;i++){
                    iids = iids + arr[i] + ','
                }
                iids = iids.substr(0,iids.length-1)
                let parm = {
                    saleiid: that.iid,
                    action_user: that.user,
                    productcodeiids: iids
                }
                that.$http.urlpost('/TransSale/SelectProductCodes', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            expstatus(value){
                if(value == 0){
                    return '草稿'
                } else if(value == 1){
                    return '新建'
                } else if(value == 2){
                    return '提交'
                } else if(value == 3){
                    return '审核'
                } else if(value == 4){
                    return '驳回修改'
                } else {
                    return ''
                }
            },
            expt() {
                let that = this;
                that.loading = true;
                if(that.browser == false) {
                    that.begintime = that.begintime.replace(/\//g,"-")
                    that.endtime = that.endtime.replace(/\//g,"-")
                }
                let parm = {
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                    QueryKey: that.queryKey,
                    iid: "",
                    SortList: that.SortList,
                    ScreenList: that.ScreenList,
                    begintime: that.begintime,
                    endtime: that.endtime,
                    status: that.status,
                    dealercode: that.usercode
                };
                that.$http.urlpost('/TransSale/Export', parm, function (res) {
                     that.loading = false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.Key;
						window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            expdealeriid(value){
                let that = this
                let str = ''
                if(value != ''){
                    let arr = value.split(',')
                    that.arrsondealeriid.forEach(item=>{
                        arr.forEach(item2=>{
                            if(item.iid==item2){//可获取对应的name
                                str += item.dealername+','
                            }
                        })
                    })
                }
                return str.substr(0,str.length-1)
            },
            download(){
                let that = this
                let parm = {
                    TemplateID: 4,
                };
                that.$http.urlpost('/Template/Download', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.Key;
						window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });

            },
            //上传成功回调
            handleSuccess(res, file, fileList){
                let that = this;
                that.fileList=[];
                if(res.Success==0){
                    that.$message.error(res.Msg);
                }else{
                    that.$message.success(res.Msg);
                    that.getView();
                }
                if(res.Key!=null){
                    let hrefurl = Common.Url + res.Key;
                    window.open(hrefurl);
                }
                
            },
            handleError(err, file, fileList){
                let that = this;
                that.fileList=[];
                that.$message.error('上传失败:' + err)
            },
            showFile(row){
                let that = this
                that.isShowFile = true
                that.fileArr = row.split(',')
            },
            checkFile(value) {
                let that = this;
                window.open(Common.Url + 'uploads/' + value);
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i].iid);
                }
            },
            //批量删除
            ifBatchDel(){
                let that = this
                that.$confirm('是否批量删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.batchDel();
                    })
                    .catch(() => {});
            },
            batchDel(){
                let that = this
                let iids = Common.methods.arrToStr(that.selectData)
                let parm ={
                    iid: iids,
                    createpersonname: that.user
                }
                that.$http.urlpost('/TransSale/Delete', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            explevel(value){
                if(value == 0){
                    return '普通'
                } else if (value == 1){
                    return '市代'
                } else if(value == 2){
                    return '省代'
                } else if(value == 3){
                    return 'B类'
                }
            }
        }
    };
</script>

<style scoped lang="less">
    /deep/.cell{
        display: flex
    }
</style>
